import { severityMap } from 'pages/Asset/tabs/Cases/components/Filters/CasesSummaryPanel';
import { useTranslation } from 'react-i18next';
import './style.scss';
const severityMapKeys = Object.keys(severityMap).reverse();
const NORMAL_STATUS = 'normal';

export const PdfAssetCaptions = () => {
  const { t } = useTranslation();

  return (
    <div className="pdf-caption">
      <span className="pdf-caption-title pdf-caption-text">{t(`pdf:severity.title`)}:</span>
      {[...severityMapKeys, NORMAL_STATUS].map((caption) => (
        <div className="pdf-caption-box-wrapper" key={caption}>
          <span className={`pdf-caption-box pdf-caption-color-${caption}`} />
          <span className="pdf-caption-text">{t(`pdf:severity.${caption}`)}</span>
        </div>
      ))}
    </div>
  );
};
